import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { IS_PASSWORD_SYSTEM_GENERATED } from "../redux/constants/Auth";

function SetPasswordRoute() {
  const isPasswordTrue =
    localStorage.getItem(IS_PASSWORD_SYSTEM_GENERATED) === "true"
      ? true
      : false;
  return isPasswordTrue ? <Outlet /> : <Navigate to="/landing-page" />;
}

export default SetPasswordRoute;
